import React from "react";
import { WSCalendlyWidget } from "@wingspanhq/fe-component-library";
import { track } from "../../utils/analytics";
import { useUserId } from "../../query/hooks/helpers";
import { useAdvocate } from "../../query/user";
import { useUserProfile } from "../../query/users/queries";
import { WSQueries } from "../../query/WSQuery";

export type CalendlyProps = {
  url?: string;
  children(props: { onOpen(): void }): React.ReactNode;
};

export const Calendly: React.FC<CalendlyProps> = ({ url, children }) => {
  const userId = useUserId();
  const advocateQuery = useAdvocate(userId);
  const userQuery = useUserProfile(userId);
  const defaultURL = "https://calendly.com/wingspan-support/wade-warren";

  return (
    <WSQueries queries={{ advocateQuery, userQuery }}>
      {({ userQuery: { data: user }, advocateQuery: { data: advocate } }) => {
        const advocateName = `${advocate.firstName} ${advocate.lastName}`;
        const userEmail = user.email;
        const userName = `${advocate.firstName} ${advocate.lastName}`;
        return (
          <WSCalendlyWidget
            url={url || advocate?.schedulingUrl || defaultURL}
            userEmail={userEmail}
            userName={userName}
            onEventTypeViewed={() => {
              track("Calendly Event Type Viewed", {
                userName,
                userEmail,
                advocateName
              });
            }}
            onDateAndTimeSelected={() => {
              track("Calendly Date and Time Selected", {
                userName,
                userEmail,
                advocateName
              });
            }}
            onEventScheduled={() => {
              track("Calendly Event Scheduled", {
                userName,
                userEmail,
                advocateName
              });
            }}
            onProfilePageViewed={() => {
              track("Calendly Profile Page Viewed", {
                userName,
                userEmail,
                advocateName
              });
            }}
            onCloseWithoutSchedule={() => {
              track("Calendly Closed", {
                userName,
                userEmail,
                advocateName
              });
            }}
          >
            {children}
          </WSCalendlyWidget>
        );
      }}
    </WSQueries>
  );
};
